import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();

    return (
        <div className={styles.TheComp}>
            <div className="box">
                <div className="info-box">
                    <p className="label">{pageStatus === 'statusA' ? t('E_coming') : t('E_new')}</p>
                    <p className="title">{t('E_title')}</p>
                    <ul className="items">
                        {Array(4)
                            .fill(0)
                            .map((item: any, k: number) => (
                                <li className="item" key={k}>
                                    {t(`E_item${k + 1}`)}
                                </li>
                            ))}
                    </ul>
                </div>
                <div className="img-box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726801056095/tm_battery.png" />
                </div>
            </div>
            <EfLink
                href={`https://www.ecoflow.com/${locale}/12v-lithium-trolling-motor-battery`}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'select_product',
                    list_name: t('E_title'),
                    product_name: t('E_title'),
                    button_name: t('E_more'),
                }}
            >
                {t('E_more')} &gt;
            </EfLink>
        </div>
    );
}
